<template>
  <AppAdsense
    ad-style="display:block"
    ad-client="ca-pub-9118328092882671"
    ad-slot="8539076245"
    ad-format="auto"
    ad-responsive="true"
  />
</template>
